<template>
  <AppleTvSlider />
</template>

<script>
import AppleTvSlider from '@/components/AppleTvSlider.vue';

export default {
  name: 'FeatureGrid',
  components: {
    AppleTvSlider
  }
}
</script>

<style scoped>
</style>
